import { NotificationData, showNotification } from '@mantine/notifications';

import { TOAST_CLASS_NAMES, ToastVariant, VARIANT_ICONS } from './Toast';

export type ShowToastConfig = Omit<
  NotificationData,
  'unstyled' | 'classNames'
> & {
  /** Toast variant that determines icon and styling */
  variant?: ToastVariant;
};

export const showToast = ({
  variant = 'general-note',
  message,
  icon,
  ...config
}: ShowToastConfig) => {
  const resolvedIcon = icon ?? VARIANT_ICONS[variant];

  return showNotification({
    ...config,
    message,
    unstyled: true,
    classNames: TOAST_CLASS_NAMES,
    icon: resolvedIcon,
    'data-variant': variant,
  });
};

export const showSuccessToast = (config: Omit<ShowToastConfig, 'variant'>) => {
  return showToast({ ...config, variant: 'success' });
};

export const showErrorToast = (config: Omit<ShowToastConfig, 'variant'>) => {
  return showToast({ ...config, variant: 'error' });
};

export const showWarningToast = (config: Omit<ShowToastConfig, 'variant'>) => {
  return showToast({ ...config, variant: 'warning' });
};
